import { gql } from "@apollo/client";

export const RETRIEVE_INSURANCE_SERVICE_LOGS = gql`
  mutation retrieveInsuranceServiceLogs($input: RetrieveInsuranceServiceLogsInput!) {
    retrieveInsuranceServiceLogs(input: $input) {
      commandId
      correlationId
    }
  }
`;
